var generic = generic || {};
var prodcat = prodcat || {};
var site = window.site || {};

(function ($) {
  Drupal.behaviors.customKitFormatterV1 = {
    attach: function (context) {
      var $kitFormatter = $('.js-kit-formatter-v1', context);
      var $product = $('.js-custom-kit-product', $kitFormatter);
      var $startCta = $('.js-start-cta', $kitFormatter);
      var $overlayContent = $('.js-overlay-content', $kitFormatter);
      var $step = $('.js-step', $kitFormatter);
      var $shades = $('.js-kit-product-shade', $kitFormatter);
      var $nextCta = $('.js-next-cta', $kitFormatter);
      var $edit = $('.js-edit', $kitFormatter);
      var $addToBag = $('.js-kit-add-to-bag', $kitFormatter);
      var $document = $(document);
      var $close = $('.js-overlay-close', $kitFormatter);
      var $body = $('body', context);
      var $kitItemElement, invStatus, currentBpWidth, bPMediumUp, isMobile;
      var extraSpace = 70;
      var $kitOverlayContent = $('.custom-kit-formatter__overlay-content', $kitFormatter);
      var cartData = null;
      var isCartAlreadyCotainKit = false;
      var $messageContainer;
      var kitOfferName = site.translations.product.bundle_offer_name;

      $(window).on('load', function () {
        currentBpWidth = parseInt(Unison.fetch.now().width, 10);
        bPMediumUp = parseInt(Unison.fetch.all()['usn-medium'], 10);
        isMobile = currentBpWidth <= bPMediumUp;
      });

      $shades.each(function (index, kitItem) {
        $kitItemElement = $(kitItem);
        invStatus = parseInt($kitItemElement.attr('data-inventory-status'), 10);
        if (invStatus === 2 || invStatus === 5 || invStatus === 7 || !invStatus) {
          $kitItemElement.addClass('hidden');
        }
      });

      var adjustFormatterHeight = function () {
        if (!isMobile) {
          return;
        }
        $kitFormatter.height($kitOverlayContent.height() - extraSpace);
      };

      $step.each(function (index) {
        var $this = $(this);

        $this.find('.js-step-count').text(index + 1);
        if (index === $step.length - 1) {
          $this.find('.js-step-slash').addClass('hidden');
        }
      });

      $step.on('click', function () {
        var $this = $(this);

        $step.add($product).removeClass('active');
        $this.add($product.eq($this.index())).addClass('active');
        adjustFormatterHeight();
      });

      $startCta.on('click', function () {
        if (Drupal.settings.globals_variables.one_custom_kit_allowed) {
          generic.jsonrpc.fetch({
            method: 'trans.get',
            params: [
              {
                order_fields: ['offerCodes']
              }
            ],
            onSuccess: function (jsonResponse) {
              cartData = jsonResponse.getValue();

              if (cartData.order && cartData.order.offerCodes) {
                isCartAlreadyCotainKit = ($.inArray(kitOfferName, cartData.order.offerCodes) > -1);
              }
              if (isCartAlreadyCotainKit) {
                $messageContainer = $('<div/>').html('<span class="max_error_message">' + site.translations.product.max_kit_allowed_msg + '</span>').html();

                generic.overlay.launch({
                  content: $messageContainer,
                  width: '30%',
                  onComplete: function () {
                    $(this).colorbox.resize();
                  }
                });

                return;
              }
              $body.addClass('custom-kit-overlay');
              $overlayContent.addClass('active');
              if (!$product.hasClass('active')) {
                $product.first().once().addClass('active');
                $step.first().once().addClass('active');
              }
              adjustFormatterHeight();
            },
            onFailure: function (jsonRpcResponse) {
              console.log(jsonRpcResponse.getError());
            }
          });
        } else {
          $body.addClass('custom-kit-overlay');
          $overlayContent.addClass('active');
          if (!$product.hasClass('active')) {
            $product.first().once().addClass('active');
            $step.first().once().addClass('active');
          }
          adjustFormatterHeight();
        }
      });

      $shades.on('click', function () {
        var $this = $(this);
        var $thisParent = $this.closest('.js-custom-kit-product');
        var $thisOverlay = $this.closest('.js-overlay-content');
        var $productImg = $thisParent.find('.js-kit-product-image');
        var $shadeName = $thisParent.find('.js-shade-name');
        var $shadeDesc = $thisParent.find('.js-shade-description');
        var $shadeDescSeperator = $thisParent.find('.js-shade-desc-seperator');
        var skuBaseId = $this.data('sku-base-id');
        var skuData = prodcat.data.getSku(skuBaseId);
        var shadeNameCopy = skuData.SHADENAME;
        var shadeDescCopy = skuData.SHADE_DESCRIPTION;
        var skuImg = Drupal.settings.globals_variables.images_cr21
          ? skuData.IMAGE_MEDIUM[0]
          : skuData.MEDIUM_IMAGE[0];
        var $next = $thisParent.find('.js-next-cta');
        var $selectBlurb = $thisParent.find('.js-select-blurb');
        var $shadeBlurb = $thisParent.find('.js-shade-blurb');
        var $selectedProdContainer = $thisOverlay
          .find('.js-result-prod-container')
          .eq($thisParent.index());
        var $selectedProdName = $selectedProdContainer.find('.js-selected-prod-name');
        var $selectedShadeName = $selectedProdContainer.find('.js-selected-shade-name');
        var $selectedProdImg = $selectedProdContainer.find('.js-selected-prod-img');
        var $selectedProdShade = $selectedProdContainer.find('.js-selected-shade');

        $productImg.attr('src', skuImg);
        $shadeName.html(shadeNameCopy);
        $shadeDescSeperator.removeClass('active');
        $shadeDesc.html(shadeDescCopy);
        if (shadeDescCopy) {
          $shadeDescSeperator.addClass('active');
        }
        $thisParent.find($shades).add($thisParent.find($selectBlurb)).removeClass('active');
        $this.add($next).add($shadeBlurb).addClass('active');
        $thisParent.find('.selected').removeClass('selected');

        var $selectedShade = $thisParent.find('.active.js-kit-product-shade');
        var prodName = $selectedShade.attr('data-prod-name');
        var shadeName = $selectedShade.attr('data-shade-name');
        var prodImg = $selectedShade.attr('data-medium-img');
        var hexString = $selectedShade.attr('data-hex-string');

        $selectedShade.addClass('selected');
        $selectedProdContainer.addClass('active');
        $selectedProdName.text(prodName);
        $selectedShadeName.text(shadeName);
        $selectedProdImg.attr('src', prodImg);
        $selectedProdShade.css('background', hexString);
      });

      $nextCta.on('click', function () {
        var $this = $(this);
        var $thisParent = $this.closest('.js-custom-kit-product');
        var $thisOverlay = $this.closest('.js-overlay-content');
        var $overlayHeader = $thisOverlay.find('.js-overlay-header');
        var $resultSection = $thisOverlay.find('.js-result-section');
        var $nextParentShades = $thisParent.next().find('.js-kit-product-shade');

        if (!$this.hasClass('active')) {
          return;
        }
        $thisParent.removeClass('active').next().addClass('active');
        adjustFormatterHeight();
        $step.removeClass('active');
        $step.eq($thisParent.index() + 1).addClass('active');
        if ($resultSection.hasClass('active')) {
          $overlayHeader.removeClass('active');
        }
        if (
          $thisOverlay.find('.selected').length ===
          $thisOverlay.find('.js-custom-kit-product').length
        ) {
          $addToBag.addClass('active');
        }
        if ($nextParentShades.length === 1) {
          $nextParentShades.trigger('click');
        }
      });

      $step.on('click', function () {
        var $this = $(this);
        var $product = $('.js-custom-kit-product');

        $step.add($product).removeClass('active');
        $this.add($product.eq($this.index())).addClass('active');
        adjustFormatterHeight();
      });

      $edit.on('click', function () {
        var $this = $(this);
        var $thisContainer = $this.closest('.js-result-prod-container');
        var $thisOverlay = $this.closest('.js-overlay-content');
        var containerIndex = $thisContainer.index();
        var $resultSection = $thisOverlay.find('.js-result-section');
        var $product = $thisOverlay.find('.js-custom-kit-product');
        var $overlayHeader = $thisOverlay.find('.js-overlay-header');

        $step.add($resultSection).removeClass('active');
        $step
          .eq(containerIndex)
          .add($overlayHeader)
          .add($product.eq(containerIndex))
          .addClass('active');
        adjustFormatterHeight();
      });

      $addToBag.on('click', function () {
        var args = args || {};
        var resultData = args.resultData || this.resultData;
        var selectedSkuIds = [];
        var $this = $(this);
        var $thisOverlay = $('.js-overlay-content', context);
        var $overlayHeader = $thisOverlay.find('.js-overlay-header');
        var $product = $thisOverlay.find('.js-custom-kit-product');
        var $resultContainer = $thisOverlay.find('.js-result-prod-container');
        var $nextCta = $thisOverlay.find('.js-next-cta');
        var $resultSection = $thisOverlay.find('.js-result-section');
        var $step = $thisOverlay.find('.js-step');
        var $selectedItem = $thisOverlay.find('.selected');
        var $selectedItemElem;
        var $bag = $('.js-site_bag_link', context);
        var giftwrapSku = $this.attr('data-giftwrap-sku');
        var defaultSku = $this.attr('data-default-sku');
        var offerCode = $this.attr('data-offer-code');

        if (
          $thisOverlay.find('.selected').length !==
          $thisOverlay.find('.js-custom-kit-product').length
        ) {
          return;
        }
        $close.trigger('click');
        if (defaultSku) {
          selectedSkuIds.push(defaultSku);
        }
        if (giftwrapSku) {
          selectedSkuIds.push(giftwrapSku);
        }
        $.each($selectedItem, function () {
          $selectedItemElem = $(this);
          selectedSkuIds.push($selectedItemElem.attr('data-sku-base-id'));
        });

        var kitName = $this.attr('data-kit-name');

        if (!!kitName) {
          kitName = kitName + ' ';
        } else {
          kitName = Drupal.settings.default_kit_name;
        }

        args.COLLECTION_TYPE = 'UKIT';
        args.COLLECTION_SUBTYPE = 'CUSTOM_KIT';
        args.SKU_BASE_ID = selectedSkuIds;
        args._SUBMIT = 'alter_collection';
        args.QTY = 1;
        args.COLLECTION_NAME = kitName + Math.floor(Math.random() * 10000);
        args.action = 'add,edit,create_kit';
        args.HAS_MULTIPLE_SKUS = 1;

        generic.jsonrpc.fetch({
          method: 'rpc.form',
          params: [args],
          onSuccess: function () {
            generic.jsonrpc.fetch({
              method: 'offers.apply',
              params: [
                {
                  offer_code: offerCode
                }
              ],
              onBoth: function () {
                generic.jsonrpc.fetch({
                  method: 'trans.get',
                  params: [],
                  onSuccess: function (r) {
                    resultData = r.getData();
                    $document.trigger('addToCart.toggle', [args.$addBtn]);
                    $bag.trigger('click');
                    $selectedItem.removeClass('active selected');
                    $step
                      .add($resultSection)
                      .add($nextCta)
                      .add($resultContainer)
                      .removeClass('active');
                    $step.first().add($overlayHeader).add($product.first()).addClass('active');
                  },
                  onFailure: function () {}
                });
              }
            });
          },
          onFailure: function (ss) {
            resultData = ss.getMessages();
            $document.trigger('addToCart.toggle', [args.$addBtn]);
            $document.trigger('addToCart.failure', [resultData]);
          }
        });
      });

      $close.on('click', function () {
        $overlayContent.removeClass('active');
        $body.removeClass('custom-kit-overlay');
        $kitFormatter.css('height', 'auto');
      });
    }
  };
})(jQuery);
